import CalabriLogo from '@/assets/branding/calabri/CalabriHealth.png';

const colors = {
  // Brand colors
  brand_primary: '#235821',
  brand_primary_hover: '#173116', // −10 L, −8 S
  brand_primary_highlight: '#3DB639', // +23 L, +7 S
  brand_primary_mid: '#2D772A', // +8 L,  +2 S
  brand_primary_dark: '#000000', // −25 L, −3 S (clamped)
  brand_secondary: '#0F1D0F', // hue +4°, −15 L, −13 S
  brand_accent_start: '#2F6D2E',
  brand_accent_end: '#2B7F9A',
  brand_accent_light_start: '#ECF6EC',
  brand_accent_light_end: '#DFF0F7',
  brand_complementary_accent: 'rgb(185,34,191)',
  brand_auth_gradient_mid: '#0F1D0F',
  brand_auth_gradient_end: '#000000',
  brand_auth_warp_mid: '#2D772A',
};

export default {
  name: 'Calabri Health',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CalabriLogo,
  colors,
};
